import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Header from './Header';
import MainGrid from './MainGrid';

export default function Dashboard(props) {
  const { profile, sucursal_id } = props;
  const [masivos, setMasivos] = useState([]);
  useEffect(() => {
    props.getMasivos(profile.tenant_id, sucursal_id);
  }, [props.sucursal_id]);

  useEffect(() => {
    if (props.masivos) {
      setMasivos(props.masivos);
    }
  }, [props.masivos]);

  return (
    <Box sx={{ display: 'flex' }}>
      {/* Main content */}
      <Box
        component="main"
        sx={theme => ({
          flexGrow: 1,
          overflow: 'auto',
        })}>
        <Stack
          spacing={2}
          sx={{
            alignItems: 'center',
            mx: 3,
            pb: 10,
            mt: { xs: 8, md: 0 },
          }}>
          <Header sucursal_id={sucursal_id} profile={profile} />
          <MainGrid masivos={masivos} />
        </Stack>
      </Box>
    </Box>
  );
}
